import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';
import Link from '@nubank/nuds-web/components/Link/Link';

import FullWidthSection from '../../styles/FullWidthSection/FullWidthSection';

import SectionImageBlock from './styles/SectionImageBlock';
import TextBlock from './styles/TextBlock';
import SectionTitle from './styles/SectionTitle';
import SectionContent from './styles/SectionContent';

function AutonomySection({ index }) {
  const { formatMessage } = useContext(NuDsContext);

  return (
    <FullWidthSection
      backgroundColor="pj.default"
      minHeight="0px"
    >
      <SectionImageBlock
        backgroundImage="pj-person-making-card-purchase/pj-person-making-card-purchase.jpg"
        imageWidth="100%"
        imageHeight="100%"
        alt={formatMessage({ id: 'BUSINESS_ACCOUNT.AUTONOMY.IMAGE_ALT' })}
        loading="lazy"
      />
      <TextBlock>
        <TextBlock.InnerContainer>
          <SectionTitle
            variant="title"
            intlKey={`cms.businessAccountPage.cardsArea[${index}].title`}
            color="white"
            colorVariant="dark"
            intlValues={{ br: <br /> }}
          />
          <SectionContent
            variant="subtitle"
            color="white"
            colorVariant="dark"
            intlKey={`cms.businessAccountPage.cardsArea[${index}].description`}
          />
          <Link
            typographyProps={{
              color: 'white',
              colorVariant: 'dark',
            }}
            variant="action"
            href={formatMessage({ id: `cms.businessAccountPage.cardsArea[${index}].ctaLink` })}
            intlKey={`cms.businessAccountPage.cardsArea[${index}].ctaText`}
          />
        </TextBlock.InnerContainer>
      </TextBlock>
    </FullWidthSection>
  );
}

AutonomySection.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(AutonomySection);
